<div mat-dialog-title class="dialog-title-before-none" style="margin-top: 8px;">
  <div class="valign-wrapper">
    <span class="as-card-header">{{ data?.pageTitle }}
      <form action="#">
        <mat-radio-button name="categoryClassification" id="categoryClassificationEmergency" [checked]="categoryClassification() === EMERGENCY" (change)="onCategoryClassificationChange(EMERGENCY)">
          <mat-label for="categoryClassificationEmergency">{{ 'Emergency' | translate:locale.language }}</mat-label>
        </mat-radio-button>

        <mat-radio-button name="categoryClassification" type="radio" id="categoryClassificationOperations" [checked]="categoryClassification() === OPERATIONS" (change)="onCategoryClassificationChange(OPERATIONS)">
          <mat-label for="categoryClassificationOperations">{{ 'Operations' | translate:locale.language }}</mat-label>
        </mat-radio-button>
      </form>
    </span>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col s5">
      @if (loadedMetadata()) {
        <span class="as-card-subheader" id="selectCategoryHeader">{{ 'Alert.Incident.SelectCategory' | translate:locale.language }}</span>
      }

      @if (loadedMetadata() && !hasCategories()) {
        <div class="center">
          <br/><p class="as-no-selection" id="noCategories">{{ 'Alert.Incident.NoCategories' | translate:locale.language }}</p>
        </div>
      }

      <!-- Loading metadata -->
      @if (!loadedMetadata()) {
        <div class="row loading-centered loading">
          <app-loading [hasLoaded]="loadedMetadata()" [hasFailed]="loadErrorMetadata()" (retryClicked)="fetchMetadata()"></app-loading>
        </div>
      }

      @if (hasCategories()) {
        <div class="qa-categories collection" id="categoriesCollection">
          @for (item of pageOfCategories(); track item.id) {
            <a id="singleIncidentCategory" class="qa-categories collection-item as-blue-highlight" (click)="onCategorySelect(item)" [class.active]="item.id === selectedCategory()?.id"
              (keydown.enter)="onCategorySelect(item)" (keydown.space)="$event.preventDefault(); onCategorySelect(item)" tabindex="0">{{ item.name }}</a>
          }
        </div>
      }

      @if (hasCategories()) {
        <div>
          @if (totalCategories() > pageSize) {
            <mat-paginator id="incidentCategory"
              [length]="totalCategories()" [pageSize]="pageSize" [pageIndex]="currentCategoryPage() - 1" [hidePageSize]=true
              (page)="onCategoryPageChange($event.pageIndex + 1)">
            </mat-paginator>
          }
        </div>
      }
    </div>
    <div class="col s5">
      @if (loadedMetadata()) {
        <span class="as-card-subheader" id="selectTypeHeader">{{ 'Alert.Incident.SelectIncidentType' | translate:locale.language }}</span>
      }

      @if (loadedMetadata() && !hasTypes()) {
        <div class="center">
          <br/><p class="as-no-selection" id="noTypes">{{ 'Alert.Incident.NoIncidentTypes' | translate:locale.language }}</p>
        </div>
      }

      @if (hasTypes()) {
        <div class="qa-types collection" id="typesCollection">
          @for (item of pageOfTypes(); track item.id) {
            <a id="singleIncidentType" class="qa-types collection-item as-blue-highlight" (click)="onTypeSelect(item)" [class.active]="isTypeSelected(item)"
              (keydown.enter)="onTypeSelect(item)" (keydown.space)="$event.preventDefault(); onTypeSelect(item)" tabindex="0">{{ item.name }}</a>
          }
        </div>
      }

      @if (hasTypes()) {
        <div>
          @if (categoryTypes()?.length > pageSize) {
            <mat-paginator id="incidentType"
              [length]="categoryTypes()?.length" [pageSize]="pageSize" [pageIndex]="currentTypePage() - 1" [hidePageSize]="true"
              (page)="onTypePageChange($event.pageIndex + 1)">
            </mat-paginator>
          }
        </div>
      }
    </div>
  </div>
  @if (data?.selectMultiple) {
    <div>
      @if (loadedMetadata()) {
        <span class="as-card-subheader" id="selectedTypesHeader">{{ 'Tasklist.Form.SelectedIncidentTypes' | translate:locale.language }}</span>
      }

      @if (loadedMetadata() && selectedEvents()?.length) {
        <ul class="collection qa-incident-type-collection">
          @for (event of selectedEvents(); track event.incidentType?.id) {
            <li app-selector-row [title]="event?.incidentType?.name"
              [showDrilldown]="false" [showCheckBox]="false"
              (selectedChange)="onClearType(event?.incidentType)">
            </li>
          }
        </ul>
      }

      @if (loadedMetadata() && !selectedEvents()?.length) {
        <div class="section">
          <p class="as-grey-text">{{ 'Tasklist.Form.NoIncidentTypesSelected' | translate:locale.language }}</p>
        </div>
      }
    </div>
  }
</div>
<div mat-dialog-actions class="right">
  <button mat-button id="cancel" color="primary" (click)="onCancelClick()">{{ 'Cancel' | translate:locale.language }}</button>
  @if (data?.selectMultiple) {
    <button mat-raised-button color="primary" id="okBtn" (click)="onDoneSelecting()">{{ 'OK' | translate:locale.language }}</button>
  }
</div>
